// extracted by mini-css-extract-plugin
export var alignBaseline = "_y-9";
export var alignCenter = "_y-5";
export var alignFlexEnd = "_y-7";
export var alignFlexStart = "_y-6";
export var alignSelfBaseline = "_y-e";
export var alignSelfCenter = "_y-a";
export var alignSelfFlexEnd = "_y-c";
export var alignSelfFlexStart = "_y-b";
export var alignSelfStretch = "_y-d";
export var alignStretch = "_y-8";
export var column = "_y-2";
export var columnReverse = "_y-4";
export var flex = "_y-0";
export var justifyCenter = "_y-f";
export var justifyFlexEnd = "_y-h";
export var justifyFlexStart = "_y-g";
export var justifySpaceAround = "_y-j";
export var justifySpaceBetween = "_y-i";
export var justifySpaceEvenly = "_y-k";
export var row = "_y-1";
export var rowReverse = "_y-3";
export var wrapNowrap = "_y-m";
export var wrapWrap = "_y-l";
export var wrapWrapReverse = "_y-n";